import { Provider } from 'react-redux'
import PageContainer from 'DashboardOverview/components/PageContainer'
import store from '../store'

export default function DashboardOverview(props) {
  return (
    <Provider store={store}>
      <PageContainer {...props} />
    </Provider>
  )
}
